export default __webpack_public_path__ + "static/media/impersonation.c0073c79.svg";